// style.ts
import styled from 'styled-components';
import { Button, Form } from 'antd';

export const InfoSection = styled.div`
  font-size: 21px;
  color: #747474;
  margin-top: 30px;
`;

export const InfoLabel = styled.div`
  font-size: 12.6px;
  color: #747474;
`;

export const ProfileContainer = styled.div`
  background-color: white;
  margin-bottom: 10px;
`;

export const SectionHeader = styled.div`
  background-color: #fafafa;
  text-align: left;
  padding: 5px;
  font-size: 22.4px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  margin-top: 20px;
  margin-left: 10px;
  padding-left: 20px;
  margin-bottom: 20px;
`;

export const TrashIconWrapper = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  margin-left: 10%;
  margin-top: 30px;
`;

export const Footer = styled.div`
  text-align: center;
  margin-top: 20px;
`;

export const TrashSection = styled.div`
  font-size: 21px;
  margin-top: 30px;
`;

export const BaseProfileDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 100px;
`;

export const BaseProfileTitle = styled.div`
  font-size: 28px;
  margin-top: 30px;
  margin-left: 30px;
`;
export const StyledSubmitButton = styled(Button)<{ $disabled: boolean }>`
  color: ${({ $disabled }) => ($disabled ? '#0046FF99' : 'blue')};
  background-color: white;
  border-color: ${({ $disabled }) => ($disabled ? '#0046FF99' : 'blue')};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;

export const StyledInput = styled.input`
  font-size: 14px;
  margin-top: -10px;
  padding: 6px 10px;
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 6px;

  &:disabled {
    background-color: #f5f5f5;
    color: #999; /* Soft grey text */
    cursor: not-allowed;
  }
`;

export const StyledSelect = styled.div`
  margin-bottom: 20px;

  label {
    font-size: 16px;
    margin-bottom: 5px;
    display: block;
  }

  .country-select {
    margin-top: -10px;
    width: 41.5%;
    font-size: 16px;
  }
`;

export const StyledForm = styled(Form)`
  margin-left: 40px;
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 2px;

  // optional: target the label text inside Form.Item
  .ant-form-item-label > label {
    font-size: 16px;
  }
`;

export const LogoutButton = styled(Button)`
  margin-right: 20px;
  margin-left: auto;
  margin-top: 25px;
  padding: 8px 12px;
  background: white;
  border: black 1px solid;
  border-radius: 4px;
  cursor: pointer;
`;
